import React from 'react';
import { BsCalendarEvent } from 'react-icons/bs';
import { FaWeightScale } from 'react-icons/fa6';
import { MdPendingActions } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

const COLORES_CONEXION = [
  { maxDays: 0, color: '#00ADEE', label: 'Conectado hoy' },
  { maxDays: 3, color: '#79385F', label: 'Conectado hace 1-3 días' },
  { maxDays: 7, color: '#A92A41', label: 'Conectado hace 4-7 días' },
  { maxDays: Infinity, color: '#D91C24', label: 'Desconectado por más de 7 días' },
];

const COLOR_PENDIENTE = '#D91C24';

const COLOR_ENVIADO = '#00ADEE';
const COLOR_NO_ENVIADO = '#D91C24';

const getConexionColor = (ultimaConexion) => {
  if (!ultimaConexion) return COLORES_CONEXION[3].color;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const conexion = new Date(ultimaConexion);
  conexion.setHours(0, 0, 0, 0);
  const days = Math.floor((hoy - conexion) / (1000 * 60 * 60 * 24));
  const match = COLORES_CONEXION.find(c => days <= c.maxDays);
  return match ? match.color : COLORES_CONEXION[3].color;
};

const formatFecha = (fechaStr) => {
  if (!fechaStr) return '-';
  return new Date(fechaStr).toLocaleString('es-CO', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
};

const colorCell = (bg, content) => (
  <span style={{
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    backgroundColor: bg,
    color: '#fff',
    fontWeight: 500,
    fontSize: '0.82rem',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 4px ${bg}66',
  }}>
    {content}
  </span>
);

export const estacionesColumnConfig = [
  {
    id: 'name',
    label: 'Estación',
    sortable: true,
    align: 'left',
    icon: FaWeightScale,
    width: '25%',
    formatter: (value) => value ?? '-',
  },
  {
    id: 'ultima_Conexion',
    label: 'Última conexión',
    sortable: true,
    align: 'center',
    icon: BsCalendarEvent,
    width: '19%',
    formatter: (value) => colorCell(getConexionColor(value), formatFecha(value)),
  },
  {
    id: 'registros_pendientes',
    label: 'Registros pendientes',
    sortable: true,
    align: 'center',
    icon: MdPendingActions,
    width: '17%',
    formatter: (value) => value > 0
      ? colorCell(COLOR_PENDIENTE, value)
      : (value ?? '-'),
  },
  {
    id: 'version',
    label: 'Versión',
    sortable: true,
    align: 'center',
    width: '12%',
    formatter: (value) => value ?? '-',
  },
  {
    id: 'estado',
    label: 'Estado',
    sortable: true,
    align: 'center',
    width: '15%',
    formatter: (value) => value ?? '-',
  },
  {
    id: 'send_whatsapp',
    label: 'WhatsApp',
    sortable: true,
    align: 'center',
    icon: FaWhatsapp,
    width: '12%',
    formatter: (value) => colorCell(
      value ? COLOR_ENVIADO : COLOR_NO_ENVIADO,
      value ? 'Activo' : 'Inactivo'
    ),
  },
];
